export const CITY_SERVICE_DATA = [
  {
    city: 'dallas',
    state: 'tx',
    serviceCategories: [
      'Braids',
      'Natural Hair',
      'Haircut',
      'Weaves',
      'Barber',
    ],
  },
  {
    city: 'chicago',
    state: 'il',
    serviceCategories: [
      'Braids',
      'Natural Hair',
      'Haircut',
      'Weaves',
      'Barber',
    ],
  },
  {
    city: 'atlanta',
    state: 'ga',
    serviceCategories: [
      'Braids',
      'Natural Hair',
      'Haircut',
      'Weaves',
      'Barber',
    ],
  },
  {
    city: 'washington',
    cityLabel: 'Washington, D.C.',
    state: 'd.c.',
    serviceCategories: [
      'Braids',
      'Natural Hair',
      'Haircut',
      'Weaves',
      'Barber',
    ],
  },
  {
    city: 'los angeles',
    state: 'ca',
    serviceCategories: [
      'Braids',
      'Natural Hair',
      'Haircut',
      'Weaves',
      'Barber',
    ],
  },
];
export const CITY_SERVICE_DATA2 = [
  {
    city: 'houston',
    state: 'tx',
    serviceCategories: [
      'Braids',
      'Natural Hair',
      'Haircut',
      'Weaves',
      'Barber',
    ],
  },
  {
    city: 'detroit',
    state: 'mi',
    serviceCategories: [
      'Braids',
      'Natural Hair',
      'Haircut',
      'Weaves',
      'Barber',
    ],
  },
  {
    city: 'charlotte',
    state: 'nc',
    serviceCategories: [
      'Braids',
      'Natural Hair',
      'Haircut',
      'Weaves',
      'Barber',
    ],
  },
  {
    city: 'columbus',
    state: 'oh',
    serviceCategories: [
      'Braids',
      'Natural Hair',
      'Haircut',
      'Weaves',
      'Barber',
    ],
  },
  {
    city: 'newport news',
    state: 'va',
    serviceCategories: [
      'Braids',
      'Natural Hair',
      'Haircut',
      'Weaves',
      'Barber',
    ],
  },
];

export const TRACKING_ATTRIBUTION = 'homepage_seo_link';

export const SEARCH_URL_PREFIX = '/m/search/';
